<footer>
  <div class="row">
    <div class="col">
      <img src="assets/img/logos/logo-gesvatec-footer.webp" alt="GESVATEC PackCert" height="104">
      <p>{{ 'footer.desc' | translate }}</p>
    </div>

    <div class="col">
      <h4>{{ 'footer.colPack' | translate }}</h4>
      <ul>
        <li><a routerLink="/" fragment="evolucion">{{ 'footer.packWhat' | translate }}</a></li>
        <li><a routerLink="/" fragment="identificacion">{{ 'footer.packId' | translate }}</a></li>
        <li><a routerLink="/" fragment="caracteristicas">{{ 'footer.packFeatures' | translate }}</a></li>
        <li><a routerLink="/" fragment="blockchain">{{ 'footer.packBlockchain' | translate }}</a></li>
      </ul>
    </div>

    <div class="col">
      <h4>{{ 'footer.colSystem' | translate }}</h4>
      <ul>
        <li><a routerLink="/sistema-gesvatec">{{ 'footer.sysGesvatec' | translate }}</a></li>
        <li><a routerLink="/etiqueta">{{ 'footer.sysLabel' | translate }}</a></li>
        <li><a routerLink="/certificado">{{ 'footer.sysCert' | translate }}</a></li>
      </ul>
    </div>

    <div class="col">
      <h4>{{ 'footer.colContact' | translate }}</h4>
      <ul>
        <li><a href="mailto:info@gesvatec.com">info&#64;gesvatec.com</a></li>
        <li><a href="tel:+34963939160">+34 963 939 160</a></li>
        <li><a href="https://www.gesvatec.com" target="_blank" rel="noopener">www.gesvatec.com</a></li>
      </ul>
    </div>
  </div>

  <div class="legal">
    <span>{{ 'footer.legal' | translate }}</span>
    <nav class="legal-links">
      <a routerLink="/terminos-condiciones">{{ 'footer.linkTerms' | translate }}</a>
      <a routerLink="/politica-privacidad">{{ 'footer.linkPrivacy' | translate }}</a>
      <a routerLink="/politica-cookies">{{ 'footer.linkCookies' | translate }}</a>
    </nav>
  </div>
</footer>
